var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{class:_vm.$vuetify.breakpoint.mdAndUp ? 'mb-4' : 'mb-10',attrs:{"justify":_vm.$vuetify.breakpoint.smAndDown ? 'center' : 'start'}},_vm._l((_vm.items),function(item){return _c('v-col',{key:item.id,staticClass:"mb-5",attrs:{"cols":"12","sm":"6","md":"4","lg":"3"}},[_c('chapter-card',{attrs:{"chapter":item}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }